import classnames from 'classnames/bind';
import styles from './HotelCardLoader.module.scss';
import {useMemo} from 'react';

const cx = classnames.bind(styles);

const HotelCardLoader = function ({length = 1}) {
  const cards = useMemo(() => Array.from({ length }, (_, index) => index), [length])
  return cards.map(key => (
    <div className={cx('root')} key={key}>
      <div className={cx('image')} />
      <div className={cx('info-wrap')}>
        <div className={cx('info')} style={{width: '70%'}} />
        <div className={cx('info')} style={{width: '50%'}} />
        <div className={cx('info')} style={{width: '60%'}} />
        <div className={cx('info')} style={{width: '40%'}} />
        <div className={cx('button')} />
      </div>
    </div>
  ))
}

export default HotelCardLoader;
